export const login = (data: any) => ({
  type: 'LOGIN',
  data,
});
